import { USER_SERVICE_ENDPOINT, EHS_ENDPOINT } from 'constants/endpoint';
import { connector, ResponseBody, urlBuilder } from '../base';
import { IUserActivate } from '../auth/types';
import {
  EUserLanguage,
  IEditUserInfo,
  IInternalWhoAmiResponse,
  IWhoAmIRequest,
  IWhoAmIResponse,
  IRemainingTaskQuotaResponse,
  IUserLog,
  IRatingRequestType,
  ISessionInfo,
  IResourceItem,
} from './types';

let build = urlBuilder(`${USER_SERVICE_ENDPOINT}`);

// 我是谁
export async function whoAmI(data?: IWhoAmIRequest): Promise<ResponseBody<IWhoAmIResponse>> {
  return connector.post({
    url: build(`/whoami`),
    data: {},
  });
}

/**
 * @method GET
 * @returns IInternalWhoAmiResponse
 */
export async function internalWhoAmi() {
  return connector.get<IInternalWhoAmiResponse>({
    url: urlBuilder(`${EHS_ENDPOINT}`)(`/company/who-am-i`),
  });
}

/**
 * @method POST
 * @param params IEditUserInfo
 */
export async function editUserInfo(params: IEditUserInfo) {
  return connector.post<null>({
    url: build(`/edit-basic`),
    data: params,
  });
}

/**
 * @method POST
 * @param params { language: EUserLanguage }
 */
export async function editUserLanguage(params: { language: EUserLanguage }) {
  return connector.post<null>({
    url: build(`/preference/save`),
    data: params,
  });
}

/**
 * @method POST
 * @param params IUserActivate
 */
export async function userActivate(params: IUserActivate) {
  return connector.post<null>({
    url: build(`/password/setup`),
    data: params,
  });
}

/**
 * @method POST
 * @param email { email: string; password: string }
 * @returns null
 */
export async function emailReset(params: { email: string; password: string }) {
  return connector.post<null>({
    url: build(`/email/reset`),
    data: params,
  });
}

/**
 * @method GET
 * @returns IRemainingTaskQuotaResponse
 */
export async function remainingTaskQuota() {
  return connector.get<IRemainingTaskQuotaResponse>({
    url: urlBuilder(`${EHS_ENDPOINT}`)(`/company/remaining-task-quota`),
  });
}

/**
 * @method GET
 * @returns boolean
 */
export async function getRatingShowStatus() {
  return connector.get<boolean>({
    url: urlBuilder(`${EHS_ENDPOINT}`)(`/rating-report/module-enable`),
  });
}

/**
 * @method GET
 * @returns IUserLog[]
 */
export async function getUserLog(params: { pageSize: number; pageNum: number }) {
  return connector.post<{
    pageNum: number;
    pageSize: number;
    records: IUserLog[];
    totalCount: number;
  }>({
    url: build(`/logs`),
    data: params,
  });
}

/**
 * @method GET 其他公司的评级请求
 * @param params { companyId: string }
 * @returns { endYearList:  string[] }
 */
export async function getRatingRequestList(params?: { ratingEndYear: string }) {
  return connector.get<IRatingRequestType[]>({
    url: urlBuilder(`${EHS_ENDPOINT}`)(`/rating-report/requested-report-by-company`, {
      'rating-end-year': params?.ratingEndYear ? params?.ratingEndYear : '',
    }),
  });
}

export const getUserSessionInfo = async () => {
  return await connector.get<ISessionInfo>({
    url: '/api/gvi/session',
  });
};

export const getResourceListByRoleId = async (roleId: string) => {
  return await connector.get<IResourceItem[]>({
    url: '/api/gvi/admin/resource/list',
    data: { roleId }
  });
};
export const changeUserPassword = async (params: { password: string; newPassword: string }) => {
  return await connector.post<string>({
    url: build(`/password/change`),
    data: params
  });
};
